import { useRef, useState } from "react";

const LeadImportForm = () => {
  const [file, setFile] = useState(null);
  const [msg, setMsg]   = useState("");
  const fileRef         = useRef();

  const handleUpload = () => {
    if (!file) { setMsg("Please select a file first."); return; }
    setMsg(`"${file.name}" ready to import.`);
  };

  return (
    <div className="px-1">
      <div className="d-flex align-items-center justify-content-between mb-3 pb-2" style={{ borderBottom: "2px solid #90b732" }}>
        <h6 className="fw-bold mb-0" style={{ color: "#90b732" }}>
          <i className="bi bi-upload me-2"></i>Import Lead
        </h6>
      </div>

      <div className="card shadow-sm" style={{ maxWidth: "560px" }}>
        <div className="card-body">
          {msg && <div className="alert alert-info py-2" style={{ fontSize: "13px" }}>{msg}</div>}

          <div className="mb-3">
            <label className="form-label fw-semibold" style={{ fontSize: "13px" }}>
              Upload File <span className="text-danger">*</span>
            </label>
            <input type="file" className="form-control" ref={fileRef}
              onChange={e => { setFile(e.target.files[0]); setMsg(""); }}
              accept=".xls,.xlsx,.csv" />
            <div className="form-text">Accepted formats: .xls, .xlsx, .csv</div>
          </div>

          <div className="d-flex gap-2">
            <button className="btn btn-sm" style={{ background: '#90b732', color: '#fff' }} onClick={handleUpload}>
              <i className="bi bi-upload me-1"></i>Upload
            </button>
            <a className="btn btn-outline-secondary btn-sm" href="#download">
              <i className="bi bi-download me-1"></i>Download Template
            </a>
          </div>
        </div>
      </div>

      <div className="mt-3">
        <a href="/admin/students" className="text-decoration-none" style={{ fontSize: "13px" }}>
          <i className="bi bi-arrow-left me-1"></i>Go to Lead List
        </a>
      </div>
    </div>
  );
};

export default LeadImportForm;
